import { render, staticRenderFns } from "./myCenter.vue?vue&type=template&id=b08f7ab0"
import script from "./myCenter.vue?vue&type=script&lang=js"
export * from "./myCenter.vue?vue&type=script&lang=js"
import style0 from "./myCenter.vue?vue&type=style&index=0&id=b08f7ab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports